import {Field} from './crud/Field';
import {Config} from './crud/Config';

export class ModalFields {
    public fields: Array<Field>;
    public config: Config;
    public mode_edit: boolean;
    public mode_delete: boolean;
    public mode_create: boolean;
    public firebaePath: string;

    constructor(fields: Array<Field>, config: Config, mode_edit: boolean, mode_delete: boolean, mode_create: boolean) {
        this.fields = fields;
        this.config = config;
        this.mode_edit = mode_edit;
        this.mode_delete = mode_delete;
        this.mode_create = mode_create;
    }

    public setValue(fieldName, value) {
        this.fields.forEach(field => {
            if (field.name === fieldName) {
                field.value = value;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/models/modal-fields.ts